<template>
  <div class="pricing-page">
     <transition name="fade-slide">
      <div v-if="isLoading" class="global-loader">
        <div class="loader-spinner"></div>
        <p>Loading...</p>
      </div>
    </transition>
    <!-- === FILTER ROW === -->
    <div class="filter-row"
         style="display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap;
                gap:12px; margin:0 .5rem 1.5rem .5rem; animation:fadeIn 0.4s ease;">
      <h1 style="display:flex; align-items:center; gap:8px; font-size:1.2rem; font-weight:700; color:var(--text); margin:0;">
        <i class="bx bx-credit-card" style="font-size:1.4rem; color:var(--primary);"></i>
        Pricing & Plans
      </h1>

      <div style="display:flex; align-items:center; gap:10px; flex-wrap:wrap;">
        <!-- Website Dropdown -->
        <select v-model="selectedWebsite"
                style="padding:8px 12px; border:1px solid var(--border); border-radius:6px;
                       background:var(--card); color:var(--text); font-size:13px; min-width:160px;">
          <option disabled value="">-- Select Website --</option>
          <option v-for="web in websites" :key="web.website_id" :value="web.website_id">
            {{ web.website_domain }}
          </option>
        </select>

        <!-- Status Dropdown -->
        <select v-model="selectedStatus"
                style="padding:8px 12px; border:1px solid var(--border); border-radius:6px;
                       background:var(--card); color:var(--text); font-size:13px; min-width:140px;">
          <option>All Status</option>
          <option>Active</option>
          <option>Inactive</option>
        </select>

        <button @click="applyFilters"
                style="display:inline-flex; align-items:center; gap:6px; background:var(--primary);
                       color:#fff; border:none; border-radius:6px; padding:8px 16px;
                       font-size:13px; font-weight:600; cursor:pointer; transition:all 0.3s ease;">
          <i class="bx bx-search"></i> Apply
        </button>

        <!-- ADD NEW PLAN — NOW ROUTES TO PAGE -->
        <router-link to="/add_web_plan"
                style="display:inline-flex; align-items:center; gap:6px; background:var(--primary);
                       color:#fff; border:none; border-radius:6px; padding:8px 16px;
                       font-size:13px; font-weight:600; cursor:pointer; text-decoration:none;
                       transition:all 0.3s ease;">
          <i class="bx bx-plus"></i> New Plan
        </router-link>
      </div>
    </div>

    <!-- === KPI ROW === -->
    <div class="kpi-row" style="display:flex; flex-wrap:wrap; gap:20px; margin-bottom:24px;">
      <div v-for="card in planStats" :key="card.title"
           class="kpi-card"
           style="flex:1; min-width:220px; background:var(--card); border:1px solid var(--border);
                  border-radius:var(--radius); padding:16px 20px; display:flex;
                  justify-content:space-between; align-items:center; box-shadow:0 2px 6px rgba(0,0,0,0.05);
                  transition:all 0.3s ease;">
        <div>
          <h4 style="margin:0; font-size:14px; color:var(--muted); font-weight:500;">{{ card.title }}</h4>
          <div style="font-size:1.4rem; font-weight:700; color:var(--text);">{{ card.value }}</div>
        </div>
        <i :class="card.icon" style="font-size:1.6rem; color:var(--primary); opacity:0.9;"></i>
      </div>
    </div>

    <!-- === PLAN CARDS GRID === -->
   <!-- === GROUPED PLAN CARDS (WEBSITE → PLANS) === -->
<div v-if="groupedPlans.length" class="plan-grid"
     style="display:flex; flex-direction:column; gap:28px; animation:fadeIn 0.4s ease;">

  <!-- LOOP GROUPED WEBSITES -->
  <div v-for="(group, index) in groupedPlans" :key="index" class="website-group">

    <!-- WEBSITE HEADER CARD -->
    <div class="website-header-card"
         style="background:var(--card); border:1px solid var(--border); padding:16px; border-radius:var(--radius);
                box-shadow:0 2px 6px rgba(0,0,0,0.05); margin-bottom:10px;">

      <h3 style="margin:0; font-size:1.1rem; font-weight:700; color:var(--text); display:flex; align-items:center; gap:8px;">
        <i class="bx bx-globe" style="color:var(--primary); font-size:1.3rem;"></i>
        {{ group.website?.website_domain || "Unknown Website" }}
      </h3>

      <p style="margin-top:4px; font-size:13px; color:var(--muted);">
        {{ group.plans.length }} Plans Found
      </p>
    </div>

    <!-- PLAN CARDS UNDER THIS WEBSITE -->
    <div class="plan-grid"
         style="display:flex; flex-wrap:wrap; gap:20px; justify-content:flex-start;">

      <div v-for="plan in group.plans" :key="plan.website_plan_id"
           class="plan-card"
           style="flex:0 0 calc(33.333% - 20px); background:var(--card); border:1px solid var(--border);
                  border-radius:var(--radius); box-shadow:0 2px 6px rgba(0,0,0,0.05); padding:16px;
                  display:flex; flex-direction:column; justify-content:space-between;
                  transition:all 0.3s ease; min-width:260px;">

        <!-- === Header === -->
        <div>
          <div style="display:flex; justify-content:space-between; align-items:center;">
            <h4 style="margin:0; font-size:1rem; font-weight:600; color:var(--text);">
              {{ plan.website_plan_title }}
            </h4>
            <span :class="'status ' + (plan.website_plan_status === 'active' ? 'active' : 'deactive')"
                  style="padding:4px 10px; border-radius:6px; font-size:0.8rem; font-weight:600;">
              {{ plan.website_plan_status }}
            </span>
          </div>

          <p style="margin-top:8px; font-size:13px; color:var(--muted); line-height:1.5;">
            Duration: {{ plan.website_plan_duration }} ({{ plan.website_plan_type }})
          </p>
        </div>

        <!-- === Price === -->
        <div style="margin-top:8px; font-size:13px; color:var(--text);">
          <strong>{{ plan.website_plan_curr }}</strong> {{ plan.website_plan_price }}
        </div>

        <!-- === Features === -->
        <ul v-if="plan.website_plan_features" style="margin-top:12px; list-style:none; padding:0;">
          <li v-for="(f, i) in plan.website_plan_features.split('\n')" :key="i"
              style="font-size:13px; color:var(--text); display:flex; align-items:center; gap:6px; margin-bottom:4px;">
            <i class="bx bx-check-circle" style="color:var(--primary); font-size:1rem;"></i>{{ f }}
          </li>
        </ul>

        <!-- === Footer === -->
        <div class="plan-footer"
             style="display:flex; justify-content:space-between; align-items:center; margin-top:14px;">
          <span style="font-size:12px; color:var(--muted);">Updated: {{ plan.website_plan_datetime }}</span>
          <div style="display:flex; gap:8px;">
            <router-link
              :to="`/add_web_plan?wid=${plan.website_plan_parent}&ptype=${plan.website_plan_type1}`"
              class="btn-edit"
              style="text-decoration:none; display:inline-flex; align-items:center; gap:4px;">
              <i class="bx bx-edit-alt"></i> Edit
            </router-link>

            <button @click="confirmDelete(plan)" class="btn-delete">
              <i class="bx bx-trash"></i> Delete
            </button>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>



    <!-- === Placeholder when no data === -->
    
    <div v-else class="empty-state">
        <i class="bx bx-layer"></i>
        <h3>No Plan Found</h3>
        <p>You haven’t created any plan yet. Let’s set up your first one.</p>
        
        <button
          class="btn-primary"
          @click="gotoplan"
          style="padding: 8px 14px; font-size: 13px; border-radius: 6px;"
        >
          <i class="bx bx-plus" style="font-size: 14px; color: white; margin-top: .7rem;"></i> Create New Plan
        </button>
      </div>

    <!-- === PAGINATION === -->
    <div v-if="plans.length > 0" style="display:flex; justify-content:space-between; align-items:center; margin-top:24px; flex-wrap:wrap; gap:10px;">
      <span style="font-size:13px; color:var(--muted);">
        Showing {{ startIndex + 1 }}–{{ endIndex }} of {{ groupedPlans.length }} plans
      </span>
      <div style="display:flex; align-items:center; gap:6px;">
        <button @click="prevPage" :disabled="currentPage === 1"
                style="border:none; background:#F3F4F6; color:var(--text); padding:6px 10px;
                       border-radius:6px; cursor:pointer;">
          <i class='bx bx-chevron-left'></i>
        </button>
        <button style="border:none; background:var(--primary); color:#fff; padding:6px 12px;
                       border-radius:6px; font-weight:600;">{{ currentPage }}</button>
        <button @click="nextPage" :disabled="endIndex >= filteredPlans.length"
                style="border:none; background:#F3F4F6; color:var(--text); padding:6px 10px;
                       border-radius:6px; cursor:pointer;">
          <i class='bx bx-chevron-right'></i>
        </button>
      </div>
    </div>

  </div>
</template>

<script scoped>
import {
  getWebsitePlans,
  getWebsitePlanReport,
  deleteWebsitePlan,
} from "@/apis/webplanapis";
import { getWebsites } from "@/apis/webapis";
import { useToast } from "vue-toastification";

export default {
  name: "PricingPage",

  data() {
    return {
      isLoading: false,
      websites: [],
      selectedWebsite: "",
      selectedStatus: "All Status",
      currentPage: 1,
      perPage: 6,
      plans: [],
      planStats: [
        { title: "Total Plans", value: 0, icon: "bx bx-layer" },
        { title: "Active Plans", value: 0, icon: "bx bx-check-circle" },
        { title: "Inactive Plans", value: 0, icon: "bx bx-power-off" },
      ],
    };
  },

  computed: {
    filteredPlans() {
      let data = this.plans;

      if (this.selectedWebsite) {
        data = data.filter(
          (p) => p.website_plan_parent === this.selectedWebsite
        );
      }

      if (this.selectedStatus !== "All Status") {
        data = data.filter(
          (p) =>
            p.website_plan_status.toLowerCase() ===
            this.selectedStatus.toLowerCase()
        );
      }

      return data;
    },
   groupedPlans() {
  const groups = {};

      this.filteredPlans.forEach(p => {
        if (!groups[p.website_plan_parent]) {
          const website = this.websites.find(w => w.website_id == p.website_plan_parent);

          groups[p.website_plan_parent] = {
            website: website || { 
              website_domain: "Unknown Website",
              website_title: "No website found",
              website_color: "#ccc"
            },
            plans: []
          };
        }

        groups[p.website_plan_parent].plans.push(p);
      });

      return Object.values(groups);
    }

    ,

    paginatedPlans() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredPlans.slice(start, end);
    },

    startIndex() {
      return (this.currentPage - 1) * this.perPage;
    },

    endIndex() {
      return Math.min(this.startIndex + this.perPage, this.filteredPlans.length);
    },
  },

  mounted() {
    this.fetchWebsites();
    this.fetchPlans();
    this.fetchPlanReport();
  },

  methods: {
    gotoplan(){
      window.location.href = "/add_web_plan";
    },
    async fetchWebsites() {
      try {
        this.isLoading = true;
        const ldata = JSON.parse(sessionStorage.getItem("ldata"));
        const res = await getWebsites(ldata.user_id, "none");
        if (res.status && res.records?.length) {
          this.websites = res.records;
        } else {
          this.websites = [];
        }
      } catch (e) {
        console.error("Error fetching websites:", e);
      } finally {
        this.isLoading = false;
      }
    },

    async fetchPlans() {
      const toast = useToast();
      try {
        this.isLoading = true;
        const ldata = JSON.parse(sessionStorage.getItem("ldata"));
        const res = await getWebsitePlans(
          ldata.user_id,
          this.selectedWebsite,
          this.selectedStatus === "All Status" ? "" : this.selectedStatus,
          this.currentPage - 1
        );

        if (res.status) {
          this.plans = res.records || [];
        } else {
          this.plans = [];
          toast.warning(res.success || "No plans found");
        }
      } catch (error) {
        console.error("fetchPlans error:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async fetchPlanReport() {
      try {
        const ldata = JSON.parse(sessionStorage.getItem("ldata"));
        const res = await getWebsitePlanReport(ldata.user_id);
        if (res.status) {
          this.planStats = [
            { title: "Total Plans", value: res.total_plans, icon: "bx bx-layer" },
            { title: "Active Plans", value: res.active_plans, icon: "bx bx-check-circle" },
            { title: "Inactive Plans", value: res.inactive_plans, icon: "bx bx-power-off" },
          ];
        }
      } catch (e) {
        console.error("fetchPlanReport error:", e);
      }
    },

    applyFilters() {
      this.currentPage = 1;
      this.fetchPlans();
      this.fetchPlanReport();
    },

    nextPage() {
      if (this.endIndex < this.filteredPlans.length) {
        this.currentPage++;
        this.fetchPlans();
      }
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchPlans();
      }
    },

    async confirmDelete(plan) {
      const toast = useToast();
      if (
        !confirm(`Are you sure you want to delete plan "${plan.website_plan_title}"?`)
      ) {
        return;
      }

      try {
        this.isLoading = true;
        const res = await deleteWebsitePlan(plan.website_plan_id);
        if (res.status) {
          toast.success("Plan deleted successfully");
          this.fetchPlans();
          this.fetchPlanReport();
        } else {
          toast.error(res.success || "Failed to delete plan");
        }
      } catch (e) {
        console.error("deletePlan error:", e);
        toast.error("Error deleting plan");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.plan-card {
  transition: all 0.3s ease;
}
.plan-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 18px rgba(0,0,0,0.08);
}

/* Buttons */
.btn-edit, .btn-delete {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-edit {
  background: #EEF2FF;
  color: var(--primary);
}
.btn-edit:hover {
  background: var(--primary);
  color: #fff;
}
.btn-delete {
  background: #FEE2E2;
  color: #991B1B;
}
.btn-delete:hover {
  background: #DC2626;
  color: #fff;
}

/* Status Colors */
.status.active {
  background: #DCFCE7;
  color: #166534;
}
.status.deactive {
  background: #FEE2E2;
  color: #991B1B;
}

/* Responsive */
@media (max-width: 992px) {
  .plan-card { flex: 0 0 calc(50% - 20px); }
}
@media (max-width: 600px) {
  .plan-card { flex: 0 0 100%; }
}
/* =====================================================
   📱 RESPONSIVE FIX — PRICING & PLANS PAGE
   ===================================================== */

@media (max-width: 1024px) {
  /* Filter Row */
  .filter-row {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 10px !important;
    margin: 0 0.5rem 1rem 0.5rem !important;
  }

  .filter-row h1 {
    font-size: 1.1rem !important;
  }

  .filter-row div {
    width: 100% !important;
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 8px !important;
  }

  .filter-row select,
  .filter-row button {
    flex: 1 1 48% !important;
    min-width: 150px !important;
    font-size: 13px !important;
    padding: 8px 10px !important;
  }

  /* KPI Cards */
  .kpi-row {
    gap: 16px !important;
    margin-bottom: 18px !important;
  }

  .kpi-card {
    min-width: 100% !important;
    padding: 14px 16px !important;
  }

  /* Plan Cards */
  .plan-grid {
    justify-content: center !important;
    gap: 16px !important;
  }

  .plan-card {
    flex: 0 0 calc(50% - 12px) !important;
    min-width: 260px !important;
    padding: 14px !important;
  }
}

@media (max-width: 768px) {
  /* Filter Adjustments */
  .filter-row {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 12px !important;
  }

  .filter-row select,
  .filter-row button {
    width: 100% !important;
  }

  /* KPI Cards Stack */
  .kpi-row {
    flex-direction: column !important;
    gap: 14px !important;
  }

  .kpi-card {
    padding: 12px 14px !important;
  }

  /* Plan Grid */
  .plan-grid {
    gap: 14px !important;
    justify-content: center !important;
  }

  .plan-card {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    padding: 14px !important;
    margin: 0 auto !important;
  }

  /* Card Content Adjustments */
  .plan-card h4 {
    font-size: 0.95rem !important;
  }

  .plan-card p {
    font-size: 12.5px !important;
  }

  .plan-footer {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }

  /* Pagination */
  .pricing-page > div:last-child {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 10px !important;
    margin-top: 18px !important;
  }

  /* Bottom Padding */
  .pricing-page {
    padding-bottom: 2.5rem !important;
  }
}

@media (max-width: 480px) {
  .filter-row h1 {
    font-size: 1rem !important;
  }

  .filter-row select,
  .filter-row button {
    font-size: 12px !important;
    padding: 6px 10px !important;
  }

  .kpi-card {
    padding: 10px 12px !important;
  }

  .plan-card {
    padding: 12px !important;
  }

  .plan-card p {
    font-size: 12px !important;
    line-height: 1.4 !important;
  }

  .plan-footer button {
    padding: 5px 8px !important;
    font-size: 11px !important;
  }

  .pricing-page {
    padding-bottom: 2rem !important;
  }
}

/* === General Layout === */
.pricing-page {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 100px);
  animation: fadeIn 0.3s ease-in;
}

/* === Filter Row Improvements === */
.filter-row {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 12px 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.filter-row select {
  cursor: pointer;
  transition: all 0.25s ease;
}
.filter-row select:hover {
  border-color: var(--primary);
}

/* === KPI Cards Hover === */
.kpi-card {
  transition: all 0.3s ease;
}
.kpi-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.06);
}

/* === Plan Card Consistency === */
.plan-card {
  transition: all 0.3s ease;
  border-radius: 10px;
  position: relative;
}
.plan-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 18px rgba(0,0,0,0.08);
}

.plan-card h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text);
}

.plan-card p {
  color: var(--muted);
  line-height: 1.45;
}

/* === Plan Price / Details === */
.plan-card strong {
  color: var(--text);
}

/* === Empty State === */
.placeholder-box {
  text-align: center;
  padding: 60px 20px;
  border: 1px dashed var(--border);
  border-radius: var(--radius);
  background: var(--card);
  color: var(--muted);
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}
.placeholder-box i {
  font-size: 3rem;
  color: var(--primary);
  opacity: 0.8;
}
.placeholder-box p {
  margin-top: 10px;
  font-size: 14px;
  color: var(--muted);
}

/* === Buttons === */
button {
  transition: all 0.25s ease;
}

.btn-edit,
.btn-delete {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 12.5px;
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.25s ease;
}

.btn-edit {
  background: #EEF2FF;
  color: var(--primary);
}
.btn-edit:hover {
  background: var(--primary);
  color: #fff;
}

.btn-delete {
  background: #FEE2E2;
  color: #991B1B;
}
.btn-delete:hover {
  background: #DC2626;
  color: #fff;
}

/* === “Add New Plan” Button Polishing === */
.filter-row button {
  transition: all 0.3s ease;
}
.filter-row button:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

/* === Pagination Styling === */
.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
}

.pagination button {
  border: none;
  background: #F3F4F6;
  color: var(--text);
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.pagination button:hover:not(:disabled) {
  background: var(--primary);
  color: #fff;
}

.pagination button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

/* === Status Tags === */
.status.active {
  background: #DCFCE7;
  color: #166534;
}
.status.deactive,
.status.inactive {
  background: #FEE2E2;
  color: #991B1B;
}

/* === Subtle Loader Overlay (when isLoading true) === */
.loader-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(3px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.spinner {
  width: 42px;
  height: 42px;
  border: 4px solid var(--border);
  border-top: 4px solid var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* === Responsiveness Polish === */
@media (max-width: 1024px) {
  .filter-row { padding: 10px 14px; }
  .plan-card { flex: 0 0 calc(50% - 20px); }
}
@media (max-width: 768px) {
  .plan-card { flex: 0 0 100%; }
  .filter-row button {
    width: 100%;
  }
  .kpi-row {
    flex-direction: column;
  }
}
@media (max-width: 480px) {
  .filter-row select,
  .filter-row button {
    font-size: 12px;
    padding: 6px 10px;
  }
  .plan-card {
    padding: 12px;
  }
}

/* === Subtle Fade-In Animation === */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ================================
   UPDATED PLAN CARD GROUP UI
   ================================ */

/* Website Group Block */
.website-group {
  width: 100%;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 18px;
  margin-bottom: 22px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  animation: fadeIn 0.3s ease;
}

/* Website Header */
.website-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.website-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 8px;
}

.website-title i {
  color: var(--primary);
  font-size: 1.4rem;
}

.website-url {
  font-size: 13px;
  color: var(--muted);
}

/* Plans inside website */
.website-plan-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

/* Single Plan Card */
.plan-card {
  flex: 0 0 calc(33.333% - 16px);
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
  min-width: 260px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  transition: 0.25s ease;
}

.plan-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 14px rgba(0,0,0,0.08);
}

/* Name + Status */
.plan-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.plan-header h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text);
}

.plan-status {
  font-size: 0.8rem;
  padding: 4px 10px;
  border-radius: 6px;
  font-weight: 600;
}

.plan-status.active {
  background: #DCFCE7;
  color: #166534;
}

.plan-status.deactive,
.plan-status.inactive {
  background: #FEE2E2;
  color: #991B1B;
}

/* Duration, Price */
.plan-meta {
  margin-top: 10px;
  font-size: 13px;
  color: var(--muted);
}

.plan-price {
  color: var(--text);
  margin-top: 4px;
  font-size: 13px;
  font-weight: 600;
}

/* Features */
.plan-features {
  margin-top: 12px;
  list-style: none;
  padding: 0;
}

.plan-features li {
  font-size: 13px;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.plan-features i {
  color: var(--primary);
}

/* Footer */
.plan-footer {
  margin-top: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.plan-footer span {
  font-size: 12px;
  color: var(--muted);
}

.plan-footer-actions {
  display: flex;
  gap: 8px;
}

/* Responsive */
@media (max-width: 992px) {
  .plan-card {
    flex: 0 0 calc(50% - 16px);
  }
}

@media (max-width: 600px) {
  .plan-card {
    flex: 0 0 100%;
  }
}

</style>
